import React from 'react'
import cx from 'classnames'

import Spin from 'src/components/Spin'
import styles from './styles.module.less'

export default function Loader({
  styleVariation,
  className,
  spinnerClassName,
  spinnerSize,
  spinnerStyle = {},
  ...rest
}) {
  const classNames = cx({
    [styles.spinner]: true,
    [styles.staticWithHeight]: styleVariation && styleVariation === 'staticWithHeight',
    [className]: !!className,
  })

  return (
    <div data-cy='loader' className={classNames} {...rest}>
      <Spin className={spinnerClassName ?? ''} size={spinnerSize || 'sm'} {...spinnerStyle} />
    </div>
  )
}
